export default __webpack_public_path__ + "static/media/sweethome.4e464a70.jpg";